export default __webpack_public_path__ + "static/media/e2.ded34f7a.png";